import { PaymentCompany } from "../payment/paymentCompany";

export class StripePaymentData {
    CustomerId: string;
    PaymentMethodId: string;
    PaymentCompany: PaymentCompany;
}



// WEBPACK FOOTER //
// ./app/objects/customers/stripe-payment-data.ts